<template>
    <div class="flex items-center gap-4">
        <a href="https://www.youtube.com/channel/UCKCkxxpQ7-Wdn_OOyxgfvwA"
           target="_blank"
           class="rounded-full w-12 h-12 flex items-center justify-center bg-dark group">
            <FontAwesomeIcon size="lg"
                             class="text-white group-hover:scale-110 group-hover:rotate-12 transition"
                             :icon="['fab', 'youtube']"></FontAwesomeIcon>
        </a>
        <a href="https://www.instagram.com/tyreseeker/"
           target="_blank"
           class="rounded-full w-12 h-12 flex items-center justify-center bg-dark group">
            <FontAwesomeIcon size="lg"
                             class="text-white group-hover:scale-110 group-hover:-rotate-12 transition"
                             :icon="['fab', 'instagram']"></FontAwesomeIcon>
        </a>
        <a href="https://www.facebook.com/tyreseekeruk/"
           target="_blank"
           class="rounded-full w-12 h-12 flex items-center justify-center bg-dark group">
            <FontAwesomeIcon size="lg"
                             class="text-white group-hover:scale-110 group-hover:rotate-12 transition"
                             :icon="['fab', 'facebook-f']"></FontAwesomeIcon>
        </a>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
    name: "SocialLinks",
    components:
    {
        FontAwesomeIcon
    }
}
</script>

<style scoped>

</style>
